import React from 'react';
import { useNova } from '../NovaContext';
import { NOVA_IDS } from '../constants';
import { IconChevronDown } from '../icons';
import Logo from './Logo';

export default function Launcher() {
    const { state, actions, refs } = useNova();

    const hasUnread = state.unread && !state.open;
    const className = ['nova_launcher', state.sending && 'is-busy', hasUnread && 'has-unread']
        .filter(Boolean)
        .join(' ');

    return (
        <>
            <button
                ref={refs.launcherRef}
                type="button"
                className={className}
                aria-label="Open Foresee AI assistant"
                aria-expanded={state.open}
                aria-controls={NOVA_IDS.panel}
                onClick={actions.toggle}
            >
                {state.open ? <IconChevronDown size={26} /> : <Logo size="launcher" animate busy={state.sending} />}
                {hasUnread && <span className="nova_badge" aria-hidden="true" />}
            </button>
            <span className="nova_sr" role="status">{hasUnread ? 'New reply from Foresee AI' : ''}</span>
        </>
    );
}
